import styled from 'styled-components';
import { spacing, positioning } from 'ui/theme/utils';
import device from 'ui/theme/device';

export const MobileCardsContainer = styled.span`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  width: 100%;
  ${(props) => `
    ${spacing(props)}
    ${positioning(props)}
  `}
  @media ${device.medium} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media ${device.small} {
    grid-template-columns: 1fr 1fr;
  }
`;
